import { globalAxios } from "@/axios-path.js";
// fetchSaleStoreReport;
export default {
  namespaced: true,
  state: {
    config_path: {
      search_store_id: 0,
      order_status: 6,
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    clone_config_path: {
      search_store_id: 0,
      order_status: 6,
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    sale_store_list: [],
    clone_sale_store_list: [],
    sale_store_summary: {},
    export_form_sale_store: [],
  },
  mutations: {
    resetState(state) {
      state.config_path = {
        search_store_id: 0,
        order_status: 6,
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.clone_config_path = {
        search_store_id: 0,
        order_status: 6,
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.sale_store_list = [];
      state.clone_sale_store_list = [];
      state.sale_store_summary = {};
      state.export_form_sale_store = [];
    },
    resetStoreList(state) {
      state.sale_store_list = JSON.parse(
        JSON.stringify(state.clone_sale_store_list)
      );
    },
    getStoreListReport(state, data) {
      state.sale_store_list = data;
      let counter_order = 1;
      for (let val of state.sale_store_list) {
        if (val.order_code) {
          val.no = counter_order++;
          val.no_default = counter_order - 1;
        } else {
          val.no = null;
          val.no_default = counter_order - 1;
        }
      }
    },
    cloneStoreList(state) {
      state.clone_sale_store_list = JSON.parse(
        JSON.stringify(state.sale_store_list)
      );
    },
    getSaleStoreSummary(state, data) {
      state.sale_store_summary = data;
    },
    getExportFormSaleStore(state) {
      state.export_form_sale_store = [];
      let counter_order_no = 1;
      for (let val of state.sale_store_list) {
        let json_push = {
          no: val.order_code ? counter_order_no++ : null,
          order_code: val.order_code,
          order_base_code: val.order_base_code,
          order_customer_full_name: val.order_customer_full_name,
          order_rider_full_name: val.order_rider_full_name,
          store_name: val.store_name,
          item_price:
            typeof val.item_price == "number"
              ? parseFloat(val.item_price)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "",
          transport:
            typeof val.transport == "number"
              ? parseFloat(val.transport)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "",
          extra_store:
            typeof val.extra_store == "number"
              ? parseFloat(val.extra_store)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "",
          promotion:
            typeof val.promotion == "number"
              ? "- " +
                parseFloat(val.promotion)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "",
          order_com:
            typeof val.order_com == "number"
              ? parseFloat(val.order_com)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "",
          summary:
            typeof val.summary == "number"
              ? parseFloat(val.summary)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "",
          remark: val.remark,
        };
        state.export_form_sale_store.push(json_push);
      }
    },
    getExportSaleStoreSummary(state) {
      state.export_form_sale_store.push({
        order_code: "Total",
        item_price: state.sale_store_summary.item_price
          ? parseFloat(state.sale_store_summary.item_price)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
        transport: state.sale_store_summary.transport
          ? parseFloat(state.sale_store_summary.transport)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
        extra_store: state.sale_store_summary.extra_store
          ? parseFloat(state.sale_store_summary.extra_store)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
        promotion: state.sale_store_summary.promotion
          ? "- " +
            parseFloat(state.sale_store_summary.promotion)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
        order_com: state.sale_store_summary.com
          ? parseFloat(state.sale_store_summary.com)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
        summary: state.sale_store_summary.summary
          ? parseFloat(state.sale_store_summary.summary)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
      });
    },
    cloneConfigPath(state) {
      state.clone_config_path = JSON.parse(JSON.stringify(state.config_path));
    },
    calSaleStoreSummary(state) {
      state.sale_store_summary.item_price = 0;
      state.sale_store_summary.transport = 0;
      state.sale_store_summary.extra_store = 0;
      state.sale_store_summary.promotion = 0;
      state.sale_store_summary.com = 0;
      state.sale_store_summary.summary = 0;
      for (let val of state.sale_store_list) {
        state.sale_store_summary.item_price += parseFloat(val.item_price);
        state.sale_store_summary.transport += parseFloat(val.transport);
        state.sale_store_summary.extra_store += parseFloat(val.extra_store);
        state.sale_store_summary.promotion += parseFloat(val.promotion);
        state.sale_store_summary.com += parseFloat(val.order_com);
        state.sale_store_summary.summary += parseFloat(val.summary);
      }
      state.sale_store_summary.item_price = state.sale_store_summary.item_price.toFixed(
        2
      );
      state.sale_store_summary.transport = state.sale_store_summary.transport.toFixed(
        2
      );
      state.sale_store_summary.extra_store = state.sale_store_summary.extra_store.toFixed(
        2
      );
      state.sale_store_summary.promotion = state.sale_store_summary.promotion.toFixed(
        2
      );
      state.sale_store_summary.com = state.sale_store_summary.com.toFixed(2);
      state.sale_store_summary.summary = state.sale_store_summary.summary.toFixed(
        2
      );
    },
  },
  actions: {
    async filterDataReport({ commit }, send_json_data) {
      let obj = send_json_data.data.filter(
        (val) => val.order_type == send_json_data.filter_value
      );
      commit("getStoreListReport", obj);
      return obj;
    },
    async getStoreListReport({ commit, rootState, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchSaleStoreReport_getStoreListReportNew +
        config_path.search_store_id +
        "/" +
        config_path.order_status +
        "/" +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("cloneConfigPath");
        commit("getStoreListReport", res.order);
        commit("cloneStoreList");
        commit("getSaleStoreSummary", res.calculate);
        commit("getExportFormSaleStore");
        commit("getExportSaleStoreSummary");
      }
    },
    fetchReportByDistrict({ rootState, state, dispatch, commit }) {
      let url = `/api/v1/${
        rootState.backOffice.province
      }/search_by_district/sale_store_report/store_id/order_status/datetime_start/datetime_end/${
        state.config_path.search_store_id
      }/${state.config_path.order_status}/${state.config_path.datetime_start}/${
        state.config_path.datetime_end
      }`;

      let payload = {
        district: state.config_path.district_id,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          commit("cloneConfigPath");
          commit("getStoreListReport", res.order);
          commit("cloneStoreList");
          commit("getSaleStoreSummary", res.calculate);
          commit("getExportFormSaleStore");
          commit("getExportSaleStoreSummary");
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
  },
  getters: {},
};
